// Dev auth (src/devAuth.js) has to seed the saved session before Firebase initializes, i.e.
// before the app is loaded. `require` keeps the app in the main bundle, and the development
// branch is dropped from production builds.
if (process.env.NODE_ENV === "development") {
  require("./devAuth")
    .setupDevAuth()
    .finally(() => require("./bootstrap"));
} else {
  require("./bootstrap");
}
